export default __webpack_public_path__ + "static/media/DMSans-Bold.c423ce2d.woff";